import { Row, Table } from 'antd';
import { ColumnsType } from 'antd/es/table';
import { useEffect, useState } from 'react';
import { Col } from 'react-bootstrap';
import { useDispatch } from 'react-redux';
import { toast } from 'react-toastify';
import ModalTextForm from '../../components/modal/ModalTextForm';
import { layDSLoiViPhamKPI } from '../../services/kpi';
import { hideLoadingScreen, showLoadingScreen } from '../../store/reducers/loading';

const ModalTongHopLoiViPham = ({ thangNam, show, onClose }: { thangNam: string, show: boolean, onClose: () => void }) => {
    const dispatch = useDispatch();
    const [loiViPhams, setLoiViPham] = useState<Array<any>>([]);
    const layDuLieu = async () => {
        try {
            dispatch(showLoadingScreen());
            var data = await layDSLoiViPhamKPI(thangNam);
            setLoiViPham(data);
        } catch (e) {
            toast.error("Không thể lấy thông tin ");
        }
        dispatch(hideLoadingScreen());
    }

    useEffect(() => {
        if (thangNam != "") {
            layDuLieu();
        }
    }, [thangNam]);

    const columns: ColumnsType<any> = [
        {
            title: 'STT',
            key: "STT",
            width: "8px",
            align: "center",
            onCell: (_, index) => ({
                rowSpan: _.rowSpan,
            }),
            dataIndex: "stt"
        },
        {
            title: 'Tên nhân viên',
            key: "hoTen",
            onCell: (_, index) => ({
                rowSpan: _.rowSpan,
            }),
            dataIndex: "hoTen"
        },
        {
            title: 'Chức vụ',
            key: "tenChucVu",
            onCell: (_, index) => ({
                rowSpan: _.rowSpan,
            }),
            dataIndex: "tenChucVu"
        },
        {
            title: 'Phòng ban',
            key: "tenDonVi",
            onCell: (_, index) => ({
                rowSpan: _.rowSpan,
            }),
            dataIndex: "tenDonVi"
        },
        {
            title: 'Tổng số lỗi',
            key: "tongSoLoi",
            align: "center",
            onCell: (_, index) => ({
                rowSpan: _.rowSpan,
            }),
            dataIndex: "tongSoLoi"
        },
        {
            title: 'Thời gian',
            key: "thangNam",
            align: "center",
            onCell: (_, index) => ({
                rowSpan: _.rowSpanThang,
            }),
            dataIndex: "thangNam"
        },
        {
            title: 'Nội dung',
            key: "noiDung",
            onCell: (_, index) => ({
                rowSpan: 1,
            }),
            dataIndex: 'noiDung',
        },
    ];
    return (
        <ModalTextForm show={show} hideFooter
            title="Tổng hợp lỗi trong năm"
            handleClose={() => {
                onClose();
            }}
            size="xl">
            <Row>
                <Col>
                    <Table
                        locale={{ emptyText: "Không có dữ liệu" }}
                        dataSource={loiViPhams}
                        pagination={false}
                        bordered
                        columns={columns}
                    >
                    </Table>
                </Col>
            </Row>
        </ModalTextForm>
    );
};

export default ModalTongHopLoiViPham;
